/**
 * Same pattern as `website/wateriia.com.np/src/lib/apiBase.js`:
 * `REACT_APP_API_BASE_URL` or `REACT_APP_BACKEND_URL` — origin only, no trailing slash, no `/api`.
 * Resolves to `${origin}/api` or `/api` when unset (same-origin proxy).
 */
export function getApiOrigin() {
  const raw =
    process.env.REACT_APP_API_BASE_URL ||
    process.env.REACT_APP_BACKEND_URL ||
    "";
  return String(raw ?? "").trim().replace(/\/$/, "");
}

/** Absolute `origin/api`, or `/api` if env is unset. */
export function getApiBase() {
  const origin = getApiOrigin();
  return origin ? `${origin}/api` : "/api";
}

/**
 * Sets `X-Wateriia-Lead-Source` on contact/partner POSTs. Use in `.env.development` and
 * `.env.production` so Website Leads stay correct (localhost has no public `Origin`).
 */
export function getWebsiteLeadSourceHeaders() {
  const raw = String(process.env.REACT_APP_LEAD_SOURCE_DOMAIN || "").trim().toLowerCase();
  if (raw !== "wateriia.com" && raw !== "wateriia.com.np") return {};
  return { "X-Wateriia-Lead-Source": raw };
}
